import React, {Component} from "react";
import {Button} from "primereact/button";
import CorporateActionView from "./CorporateActionView";
import {CorporateActionService} from "../../service/admin/corporateAction/CorporateActionService";
import {Growl} from "primereact/growl";
import {
    CORPORATE_ACTION_ROUTE,
    DETAIL_CORPORATE_ACTION_ROUTE,
    EXCHANGE_ROUTE,
    PAYMENT_ROUTE,
    SPLIT_ROUTE
} from "../../utils/constants/RoutesConstants";
import {Check, Clear} from "@material-ui/icons";


export default class CorporateActionContainer extends Component {
    /**
     * Constructor de la clase CorporateActionContainer
     * en este se inicializan los valores iniciales de la clase.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);

        this.corporateActionService = new CorporateActionService();
        this.getDataCorporateActions = this.getDataCorporateActions.bind(this);
        this.corporateActionTemplate = this.corporateActionTemplate.bind(this);
        this.emisoraFilter = this.emisoraFilter.bind(this);
        this.sendEmailCorporateAction = this.sendEmailCorporateAction.bind(this);
        this.redirectApplyCorporateActionScreen = this.redirectApplyCorporateActionScreen.bind(this);
        this.loading = this.loading.bind(this);
        this.redirectDetailScreen = this.redirectDetailScreen.bind(this);

        this.state = {
            corporateActions: this.getDataCorporateActions(),
            screenCorporateActionList: [1, 2, 3, 5, 6, 7],
            splitScreenList: [1, 2],
            canjeScreenList: [3],
            paymentScreenList: [5, 6, 7],
            prueba: 'ALFA A 1',
            isLoading: true,
        }
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    /**
     * Función que construye la primer columna de la tabla de acuerdo al valor del campo apply
     * @param rowData Cada una de las líneas del DataTable.
     * @returns {*} Template de la primer columna
     */
    formatApplyTemplate(rowData) {
        let icon0 = <div><Clear color={"error"}/></div>;
        let icon1 = <div><Check color={"secondary"}/></div>;
        return (rowData['apply'] === 0  ? icon0 : icon1);
    }

    /**
     * Función que realiza el template de la última columnka de la tabla, donde se
     * muestra un botón para aplicar el ejercicio del elemento.
     * @param rowData Valor del renglón
     * @param column Valor de la columna
     * @returns {html} Template del botón editar.
     */
    corporateActionTemplate(rowData, column) {
        let idCorporateAction = rowData['idCorporateAction'];
        let screenName = rowData['corporateAction'];
        let apply = rowData['apply'];
        let screenPath = '';

        if (this.state.splitScreenList.includes(idCorporateAction)) {
            screenPath = SPLIT_ROUTE;
        } else if (this.state.canjeScreenList.includes(idCorporateAction)) {
            screenPath = EXCHANGE_ROUTE;
        } else if (this.state.paymentScreenList.includes(idCorporateAction)) {
            screenPath = PAYMENT_ROUTE;
        }

        if ((screenPath !== '') && (apply === 0)) {
            return (<Button type="button" label="Aplicar" style={{marginRight: '3em'}}
                            onClick={() =>
                                this.redirectApplyCorporateActionScreen(rowData, screenPath, screenName)}/>);
        }
    }

    /**
     * Función que hace un filtro por emisoras en la pantalla de
     * ejercicios de derecho
     */
    emisoraFilter() {
        this.setState({
            corporateActions: this.state.corporateActions.filter(
                (val) => val['fullInstrument'] === this.state.prueba)
        });
    }

    /**
     * Función que obtiene el valor de la lista de ejercicios de
     * derecho, haciendo la petición al service CorporateActionService.
     * @returns {list} Lista obtenida de la petición.
     */
    getDataCorporateActions() {
        this.loading();
        return this.corporateActionService.getCorporateAction()
            .then(corporateActions =>
                this.setState({
                    corporateActions: corporateActions,
                    isLoading: false,
                })
            );
    }

    /**
     * Función que realiza una llamada al back usando CorporateActionService
     * para enviar un correo, en la pantalla de ejercicios de derecho.
     * @returns {*}
     */
    sendEmailCorporateAction() {
        this.loading();
        this.corporateActionService.sendEmailCorpAction()
            .then(resp =>{
                    resp.message === "Success" ?
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: 'El correo se envió correctamente.'
                        }) :
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: 'No se pudo enviar el correo'
                        })
                    this.setState({isLoading: false,})
            });
    }

    /**
     * Función que redirecciona a la aplicación del ejercicio de derecho
     * cuando corresponda y a la pantalla que corresponda.
     * @param rowData Datos del objeto al que se va a aplicar el ejercicio.
     * @param path Ruta de la pantalla a la que se va a redirigir.
     * @param name Nombre de la pantalla a la que se va a redirigir.
     */
    redirectApplyCorporateActionScreen(rowData, path, name) {
        this.props.history.push({
            pathname: path,
            state: {
                returnPath: CORPORATE_ACTION_ROUTE,
                screenName: 'Administración \\ Ejercicio de Derechos \\ ' + name,
                corporateAction: rowData,
            },
        });
    }

    /**
     * Función que redirecciona al detalle de la pantalla Ejercicio de derechos.
     */
    redirectDetailScreen() {
        this.props.history.push({
            pathname: DETAIL_CORPORATE_ACTION_ROUTE,
            state: {
                returnPath: CORPORATE_ACTION_ROUTE,
            },
        });
    }


    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {corporateActions, isLoading} = this.state;

        return <CorporateActionView messagesGrowl={messagesGrowl}
                                    corporateActions={corporateActions}
                                    isLoading={isLoading}
                                    formatApplyTemplate={this.formatApplyTemplate}
                                    corporateActionTemplate={this.corporateActionTemplate}
                                    emisoraFilter={this.emisoraFilter}
                                    getDataCorporateActions={this.getDataCorporateActions}
                                    sendEmailCorporateAction={this.sendEmailCorporateAction}
                                    redirectDetailScreen={this.redirectDetailScreen}
        />

    }
};